


















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Route } from "vue-router";
import validate from "@/directives/validate";
// components
import { formComponents, formSufix } from "@/components/posts/PostTypeRegister";
import itemSchedule from "@/components/posts/PostSchedule.vue";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";
// types
import { Post, RecurenceEnum, Properties } from "@/services/posts/types";
import { Channel, AllowedPostSettings } from "@/services/channels/types";
import { ContentTemplate } from "@/services/contentTemplates/types";
import { postCommonValidators } from "@/components/posts/postCommonValidators";
// service methods
import { createPost, getPost, updatePost } from "@/services/posts/postsService";
import { getChannelById } from "@/services/channels/channelsService";
import { PermitionEnum, HavePermition } from "@/components/security/Permitions.ts";
import { validateForm } from "@/services/validation/validationService";
import { getApplicationSettings } from "@/services/applicationSettings/applicationSettingsService";
import { bus } from "@/bus";
import i18n from "@/i18n";

@Component<PostForm>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    components: {
        ...formComponents,
        itemSchedule,
        HeaderActionButtons,
        UnsavedFormModal
    },
    filters: {
        form(value: string) {
            if (!value || value === "") return "";
            return value.concat(formSufix);
        }
    },
    directives: {
        validate
    }
})
export default class PostForm extends Vue {
    @Prop() postId!: string;
    @Prop() postType!: string;
    @Prop() channelId!: string;
    @Prop() contentTemplateId!: string;
    @Getter("getCurrentUser", { namespace: "authentication" }) getCurrentUser: any;
    // local state
    item = {
        id: "",
        postType: this.postType,
        name: "",
        order: 0,
        channelId: this.channelId,
        status: "",
        properties: {} as Properties,
        fromDate: new Date().toDateString(),
        toDate: "",
        fromTime: "08:00",
        toTime: "16:00",
        allDay: true,
        neverending: true,
        recurenceType: RecurenceEnum.daily,
        recurenceValues: [] as Number[],
        yearly: "",
        containsPersonalData: false
    } as Post;

    channel = {} as Channel;
    contentTemplate = {} as ContentTemplate;
    permitionEnum = PermitionEnum;
    havePermition = HavePermition;
    itemScheduled = false;
    videoDuration = "";
    showTime = 0;
    validators = postCommonValidators;
    applicationSettings = { distinguishPersonalDataPosts: false };
    i18n = i18n;

    // used for comparing if form have changes
    priorItemState = JSON.parse(JSON.stringify(this.item)) as Post;

    nextRoute = "";
    saveClicked = false;
    continue = false;
    fetchingActive = false;
    routeParams = {};
    preventSave = false;
    preventBack = false;
    localId = this.postId || "";
    nameEditMode = false;

    // lifecycle hooks
    async created() {
        this.fetchData();
        this.applicationSettings = await getApplicationSettings({ keys: ["DistinguishPersonalDataPosts"] });
    }

    // computed
    get editMode() {
        return !!this.localId;
    }

    get postTypeKey(): string {
        if (this.postType) { return this.postType; }
        if (this.item && this.item.postType) { return this.item.postType; }
        return "";
    }

    get postTypeFormatted() {
        return this.toCamelCase(this.postTypeKey);
    }

    get nameEditedByUser() :boolean {
        return this.item.name !== "";
    }

    // methods
    toCamelCase(value: string) {
        return value.length > 5 ? value.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, "") : value.toLowerCase();
    }

    fetchData() {
        if (this.channelId) {
            this.fetchingActive = true;
            getChannelById(this.channelId).then(response => {
                this.channel = response;
                bus.$emit("breadCrumbsName", this.channel.name);
                if (this.localId) {
                    getPost(this.localId).then(response => {
                        this.item = response;
                        bus.$emit("documentTitle", this.item.name);
                        this.item.fromTime = !this.item.fromTime ? "08:00" : this.item.fromTime.split("T")[1].slice(0, -3);
                        this.item.toTime = !this.item.toTime ? "16:00" : this.item.toTime.split("T")[1].slice(0, -3);
                        this.channelId = this.item.channelId;
                        if (this.postTypeFormatted !== "video") {
                            this.showTime = (this.item.properties as any).showTime;
                        }
                        this.priorItemState = JSON.parse(JSON.stringify(this.item));
                        this.priorItemState.properties = JSON.parse(JSON.stringify(this.item.properties));
                        this.priorItemState.fromDate = new Date(this.item.fromDate.split("T")[0]).toDateString();
                        if (!this.priorItemState.neverending) {
                            this.priorItemState.toDate = new Date(this.item.toDate.split("T")[0]).toDateString();
                        }
                        this.fetchingActive = false;
                    });
                } else {
                    if (this.postTypeFormatted !== "video") {
                        this.showTime = this.channel.defaultShowTime;
                        (this.priorItemState.properties as any).showTime = this.channel.defaultShowTime;
                        this.fetchingActive = false;
                    }
                }
            });
        }
    }

    async onBeforeRouteLeave(to: Route, next: any) {
        if (this.saveClicked || this.continue || this.fetchingActive) {
            next();
        } else {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            this.retrieveData();
            const noChanges = this.lodash.isEqual(this.priorItemState, this.item);
            if (noChanges) {
                next();
            } else {
                next(false);
                (this.$refs.UnsavedFormModal as any).open();
            }
        }
    }

    onContinue(data: boolean) {
        this.continue = data;
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams });
        this.nextRoute = "";
    }

    async save(back: boolean) {
        if (this.saveClicked) return;

        this.saveClicked = true;
        if (await this.validateForm()) {
            this.saveClicked = false;
            this.scrollToInvalidArea();
            return;
        }
        this.item.channelId = this.channelId;

        if (this.editMode) {
            updatePost(this.item).then(() => {
                if (back) this.goBackToChannel();
                this.saveClicked = false;
                this.priorItemState = JSON.parse(JSON.stringify(this.item)) as Post;
            });
            return;
        }
        createPost(this.item).then((id: string) => {
            if (back) this.goBackToChannel();
            else {
                this.localId = id;
                this.item.id = id;
                this.saveClicked = false;
                this.priorItemState = JSON.parse(JSON.stringify(this.item)) as Post;
            }
        });
    }

    scrollToInvalidArea() {
        const el = this.$el.querySelector(".is-invalid");
        const rect = el!.getBoundingClientRect();
        window.scrollTo(rect.left, rect.top);
    }

    goBackToChannel() {
        if (this.havePermition(this.getCurrentUser.permissions, this.permitionEnum[this.permitionEnum.UpdateChannel])) {
            this.$router.push({
                name: "updatechannel",
                params: { channelId: this.channelId }
            });
        } else {
            this.$router.push({
                name: "editorupdatechannel",
                params: { channelId: this.channelId }
            });
        }
    }

    async validateForm(): Promise<boolean> {
        const formComponent = this.$refs.form as any;
        const scheduleComponent = this.$refs.itemSchedule as any;
        let propertiesValidationState = false;

        if (formComponent) {
            formComponent.emitData();
            propertiesValidationState =
                typeof formComponent.validateData === "function"
                    ? formComponent.validateData()
                    : true;
        }

        if (scheduleComponent) {
            scheduleComponent.checkIfFormIsValid();
        }
        const rootFormValidationState = await validateForm([this.validators]);

        return new Promise(resolve =>
            resolve(!this.itemScheduled || !propertiesValidationState || !rootFormValidationState));
    }

    // Retrieve data from subcomponents
    retrieveData() {
        const formComponent = this.$refs.form as any;
        if (formComponent) {
            formComponent.emitData();
        }
    }

    back() {
        window.history.go(-1);
    }

    onPropertiesUpdated(properties: Properties) {
        this.item.properties = properties;
        if (this.postTypeFormatted !== "video") {
            ((this.item.properties as any).showTime as number) = parseInt(this.showTime.toString());
        }
    }

    onItemNameUpdated(name: string) {
        if (this.editMode || this.nameEditedByUser) return;
        this.item.name = name;
        this.validators.name.state = !!this.item.name;
    }

    onScheduleUpdated(isValid: boolean) {
        this.itemScheduled = isValid;
    }

    onSetDuration(videoLength: number) {
        if (videoLength === 0) { // A video length value of 0 indicates the absence of any videos.
            if (this.videoDuration === "") { // If videoDuration is already empty string then keep the local showTime value on changing the image through direct upload as well.
                return;
            }

            this.videoDuration = "";
            this.showTime = (this.item.properties as any).showTime || this.channel.defaultShowTime;
        } else {
            this.videoDuration = new Date(videoLength * 1000).toISOString().substr(11, 8);
            this.showTime = videoLength;
        }
    }

    onSetDefaultValues(properties: string) {
        this.priorItemState.properties = JSON.parse(properties);
    }

    onToggleHeaderButtons(state: boolean) {
        this.preventSave = !state;
        this.preventBack = !state;
    }

    get postSettingsModel() : AllowedPostSettings {
        if (this.channel && this.channel.allowedPostTypes) {
            const model = this.channel.allowedPostTypes.find(x => x.postType === this.postTypeKey);
            return model || { postType: this.postTypeKey } as AllowedPostSettings;
        }
        return {} as AllowedPostSettings;
    }
}
